export const joinClassNames = (...classes) => classes.filter(Boolean).join(' ');

export const isEmptyObject =(obj) =>  obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const renamePropertyInObjectList = (objList, oldKey, newKey) => {
    let newObjList = [];
    for (const obj of objList) {
        const { [oldKey]: replaceByKey, ...rest } = obj;
        const newObj = { ...rest, [newKey]: replaceByKey };
        newObjList.push(newObj);
    }
    return newObjList;
}

export const determineUndeliverableItems = (items) => {
    return items.reduce((accumulator, item) => {
        if (item.deliverable) {
            return accumulator;
        }

        return accumulator + item.quantity;
    }, 0);
}
